<template>
  <div>
    <h2>
      {{ code }} {{ name }} {{ startDate | formatDates }} 到
      {{ endDate | formatDates }} 持股变动
    </h2>
    <menu-title />
    <Form ref="formInline" inline>
      <FormItem prop="user">
        <Input type="text" v-model="code" placeholder="股票代码" />
      </FormItem>
      <FormItem prop="startDates">
        <DatePicker
          type="date"
          show-week-numbers
          v-model="startDate"
          placeholder="Select date"
        ></DatePicker>
      </FormItem>
      <FormItem prop="endDates">
        <DatePicker
          type="date"
          show-week-numbers
          v-model="endDate"
          placeholder="Select date"
        ></DatePicker>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="fetchData(code, startDate, endDate)"
          >go</Button
        >
      </FormItem>
    </Form>

    <my-table :columns="headers" :data="list" :loading="loading">
      <template slot-scope="item">
        <td>{{ item.index + 1 }}</td>
        <td>
          <router-link
            :to="'/details/' + code + '/' + item.data.participantId"
            >{{ item.data.participantId }}</router-link
          >
        </td>
        <td>
          <router-link :to="'/cholding/' + item.data.participantId">{{
            item.data.participantCN
          }}</router-link>
        </td>
        <td class="t-right">{{ item.data.holding | money }}</td>
        <td class="t-right">{{ item.data.holdingChange | money }}</td>
        <td class="t-right">{{ item.data.stake }}</td>
        <td class="t-right">{{ item.data.stakeChange }}</td>
        <td class="t-right">{{ item.data.lastChangeDay | formatDates }}</td>
      </template>
    </my-table>
  </div>
</template>
<script>
import menuTitle from "../components/menu-title";
import dayjs from "dayjs";

export default {
  components: {
    menuTitle
  },
  data() {
    return {
      code: this.$route.params.code,
      name: "",
      startDate: "",
      endDate: "",
      headers: [
        {
          type: "index",
          title: "序列",
          width: 60
        },
        {
          title: "席位ID",
          key: "participantId",
          width: 90
        },

        {
          title: "券商名称",
          key: "participantCN",
          width: 280,
          align: "left"
        },
        {
          title: "持股量",
          key: "holding",
          width: 160,
          align: "right"
        },
        {
          title: "持股变动",
          key: "holdingChange",
          align: "right"
        },

        {
          title: "持股占比%",
          key: "stake",
          align: "right"
        },
        {
          title: "变动占比%",
          key: "stakeChange",
          align: "right",
          width: 160,
          sortable: true,
          sortType: "desc"
        },
        {
          title: "日最后持股",
          key: "lastChangeDay",
          align: "right"
        }
      ],
      list: [],
      loading: false
    };
  },
  methods: {
    startDates(val) {
      this.startDate = val;
    },
    endDates(val) {
      this.endDate = val;
    },
    /**
     * 取数据
     */
    async fetchData(stockCode, startTime, endTime) {
      startTime = dayjs(startTime).unix();
      endTime = dayjs(endTime).unix();
      const { data } = await this.$api.GetCassStockBrokerChange({
        stockCode,
        startTime,
        endTime
      });
      if (!data) return;
      this.list = data.holdingChangeList;
      this.name = data.name;
      // 改变地址
      this.$router.replace({
        name: "changes",
        params: { code: this.code },
        query: {
          startTime: dayjs(this.startDate).format("YYYY-MM-DD"),
          endTime: dayjs(this.endDate).format("YYYY-MM-DD")
        }
      });
    }
  },
  mounted() {
    this.code = this.$route.params.code;
    this.startDate =
      this.$route.query.startTime ||
      dayjs()
        .subtract(2, "day")
        .format("YYYY-MM-DD");
    this.endDate =
      this.$route.query.endTime ||
      dayjs()
        .subtract(1, "day")
        .format("YYYY-MM-DD");
    this.fetchData(this.code, this.startDate, this.endDate);
  },
  filters: {
    formatFloatByorder(val) {
      return parseFloat(val / 100).toFixed(2);
    },
    formatDates(val) {
      if (typeof val == "object") {
        return dayjs(+val).format("YYYY-MM-DD");
      }
      return dayjs.unix(val).format("YYYY-MM-DD");
    }
  },
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
  margin: 20px auto;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
